export default __webpack_public_path__ + "static/media/digital-marketing-businessman-holding-global-interface-128341166.d7319c89.png";